
import {IElement, IImageAttributes} from 'routes/private/Editor/types';
import {IResizeValues} from './types'
import {resolver} from '@routes/private/Editor/resolver';

export const resizeArtboardResolver = ( element: IElement, value: IResizeValues ) => {
    let updatedElementResolver = resolver(element, "resize", value);  
    
    if (value.moveChildrenX || value.moveChildrenY) {
        let moveValues: any = {x: value.moveChildrenX??0, y: value.moveChildrenY??0};
        updatedElementResolver = updatedElementChildrens(updatedElementResolver, moveValues);
    }
    
    if (value.updateName) updatedElementResolver.name = value.updateName

    return updatedElementResolver;
}

const updatedElementChildrens = (updatedElementResolver: IElement, moveValues: any) => {
    updatedElementResolver?.children?.forEach((element: IElement) => {
        let newResizeValues : IResizeValues={
            id: element.id,
            x: element.attributes.x + (moveValues.x),
            y: element.attributes.y + (moveValues.y),
            width: element.attributes.width,
            height: element.attributes.height,
            rotation: element.attributes.rotation,
            command: 'resize'
        };

        if (element.type === "Image") {
            let imageVlues = (element.attributes as IImageAttributes).image;
            newResizeValues.image = {
                x: imageVlues.x + (moveValues.x),
                y: imageVlues.y + (moveValues.y),
                width: imageVlues.width,
                height: imageVlues.height,
            };
        }

        element = resolver(element, "resize", newResizeValues);  
        if (element.children) element = updatedElementChildrens(element, moveValues);
    });
    return updatedElementResolver;
}